var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse38(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 350,
    viewBox: "0 0 332 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.861 24.9471C274.555 13.8701 279.002 14.2724 249.136 6.66678C219.269 -0.938878 188.278 -1.7818 158.464 4.20102C128.651 10.1838 100.783 22.8381 76.9318 41.2234C53.0809 59.6088 33.861 83.2519 20.7005 110.396C7.53992 137.539 0.777708 167.485 0.916216 198.006C1.05472 228.527 8.09067 258.839 21.5007 286.689C34.9108 314.538 44.4614 330.061 68.4849 349.718C102.499 349.718 68.4849 349.718 110.761 349.718L171.634 349.718C149.426 344.092 128.619 333.582 110.761 318.97C92.9032 304.358 78.4527 286.019 68.4842 265.317C58.5156 244.615 53.2854 222.083 53.1824 199.394C53.0795 176.706 58.1062 154.445 67.8893 134.268C77.6723 114.091 91.9596 96.5152 109.689 82.8482C127.419 69.1812 148.135 59.7746 170.297 55.3272C192.459 50.8798 215.498 51.5064 237.699 57.1602C259.901 62.8139 323.5 82.8482 331.5 104.5L331.5 41.2234L303.861 24.9471Z",
    fill: "#476024",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse38);
export default __webpack_public_path__ + "static/media/ellipse-38.cdc3c309259a9186e3ca04880701f7b9.svg";
export { ForwardRef as ReactComponent };